<template>
    <div class="popup" v-show="noticeShow">
        <div class="content" id="deleteRemind" >
             <div class="title">
                  {{$t('language.paySystem.Notice')}}
                  <div class="icon white-close dialog-close" @click="closePage()"></div>
             </div>
             <div class="delete-remind-content">
                  <div style="float:left;width:100%;height:80px;color:#71767e;"> {{noticeTxt}} </div>
                  <div style="float:left;" class="team-footer">
                      <div class="team-botton">
                      <button class="team-botton-left"   @click="clearPage()">{{$t('language.teamTransfer.sure')}}</button>
                      <button class="team-botton-right"  @click="closePage()">{{$t('language.common.cancel')}}</button>
                      </div>
                  </div>
             </div>
        </div>
    </div>
</template>
<script>
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data(){
        return{
       noticeShow:false,
       noticeTxt:this.$t('language.teamTransfer.cleanCurrent'),
       source:'',//打开弹窗的来源
        }
    },
    methods:{
      closePage(){
      this.noticeShow = false;
      },
      //点击yes
      clearPage(){
           var user = commonUtils.getUser();
          this.$parent.pair = [];
          this.$parent.checkSourceItem=null;
          this.$parent.checkAimItem=null;
              if(this.source=='upload'){
            var flag = localStorage.getItem(user.id+'uploadShow');
             if(!flag){
                  this.$parent.$refs.uploadCSV.uploadCsvShow=true;
                  //this.$parent.haveClickUpload=true;
             }else{
              let input_file = document.getElementById("openFile");
              input_file.click();
              }
          }
          if(this.source=='autoMatch'){
              this.$parent.autoMatch();
          }
          this.closePage();
      }
    }
}
</script>
<style>
   .delete-remind-content {
    width: 100%;
    height: 150Px;
    box-sizing: border-box;
    padding: 20px 15px;
    /*no*/
    font-size: 14px;
    /*no*/
}
 #deleteRemind {
    width: 510Px;
    height: 190Px;
}
.team-footer{
 width: 100%;
 height: 40Px;
}
.team-botton{
  display: flex;
  align-items: center; /*定义body的元素垂直居中*/
  justify-content: center; /*定义body的里的元素水平居中*/
}
.team-botton-right,.team-botton-right:hover{
 border-radius:2px;
 margin-right:30px;
 background: #fff;
 color: #5562b4;
 width: 120Px;
 border: 1Px solid #5562b4;
 
}
.team-botton-left{
  border-radius:2px;
  background: #5562b4;
  color: #fff;
  width: 120Px;
  margin-right: 20Px;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/team_transfer_popups/team_transfer_notice_popups.vue